"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decode = exports.encode = void 0;

require("core-js/modules/es6.regexp.to-string");

var _aes = _interopRequireDefault(require("crypto-js/aes"));

var _encUtf = _interopRequireDefault(require("crypto-js/enc-utf8"));

var encode = function encode(text) {
  return _aes.default.encrypt(text, process.env.VUE_APP_REMEMBER_KEY).toString();
};

exports.encode = encode;

var decode = function decode(text) {
  return _aes.default.decrypt(text, process.env.VUE_APP_REMEMBER_KEY).toString(_encUtf.default);
};

exports.decode = decode;